import {connect} from 'react-redux';
import Faq from '../components/Faq';

export default connect(
    (state) => ({
        localConfigurator: state.configurator.localConfigurator,
    }), null
)(Faq);